// extracted by mini-css-extract-plugin
export var chip = "_eb-0";
export var filterDropdown = "_eb-5";
export var filterItem = "_eb-6";
export var icon = "_eb-1";
export var removeButton = "_eb-3";
export var removeIcon = "_eb-4";
export var separator = "_eb-2";